// eslint-disable-next-line import/no-extraneous-dependencies
import { useMediaQuery } from 'react-responsive';

const useBreakpoints = () => {
  const isMobile = useMediaQuery({ query: '(max-width: 767px)' });
  const isDesktop = useMediaQuery({ query: '(min-width: 1024px)' });

  return { isMobile, isDesktop };
};

export default useBreakpoints;
